import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';

const JewelryEngraving = () => {
    const metaDetails = useSelector((state) => state.persistedReducer.meta.meta);
  return (
    <>
       <Helmet>
        <meta charSet="utf-8" />
        <title>{metaDetails.title}</title>
        <meta name="description" content={metaDetails.description}></meta>
        <meta name="keywords" content={metaDetails.keywords}></meta>
      </Helmet>
      <Container>
          <h2 className="font-weight-bold mt-5 mb-3 text-center">Jewelry Engraving</h2>
          <Row className="align-items-center">
            <Col md={6}>
              <p>
              Buying a gift for a loved one from our store? Want to add a personal touch to it? Put your feelings into words by getting a special message engraved on it by Khan Khan's experts. We carry a variety of jewelry that can be customized with a close message or a special date engraved on it. We also carry a large range of monogram pendant decorations to make a bold statement.
              </p>
              <p>Whether it’s a ring, a pendant, or some other jewelry, Khan Diamonds recording professionals will write your desired message with great precision and attention to detail to make your vision come alive and make that gift memorable.</p>
              <p>Want to know more? Visit our store in Boston, MA or Email us at <a href='mailto:halodiamonds@gmail.com'>halodiamonds@gmail.com</a> </p>
            </Col>
            <Col md={6}>
              <img
                src={require("../../../Front/themes/showcase/assets/images/services/engrave.jpg")}
                alt="certificate"
                className="img-fluid border p-1"
              />
            </Col>
          </Row>
          
        </Container>
    </>
  
  )
}

export default JewelryEngraving